export class BaseChartBuilder {
  private readonly options: Highcharts.Options;

  constructor(options = {}) {
    this.options = {
      credits: {},
      chart: {},
      title: {},
      xAxis: {},
      yAxis: {},
      series: [],
      exporting: {},
      plotOptions: {},
      tooltip: {},
      ...options,
    };
  }

  setCredits(credits: Highcharts.CreditsOptions) {
    this.options.credits = credits;
    return this;
  }

  setChart(chart: Highcharts.ChartOptions) {
    this.options.chart = { ...this.options.chart, ...chart };
    return this;
  }

  setTitle(title: Highcharts.TitleOptions) {
    this.options.title = { ...this.options.title, ...title };
    return this;
  }

  setXAxis(xAxis: Highcharts.XAxisOptions) {
    this.options.xAxis = { ...this.options.xAxis, ...xAxis };
    return this;
  }

  setYAxis(yAxis: Highcharts.YAxisOptions) {
    this.options.yAxis = { ...this.options.yAxis, ...yAxis };
    return this;
  }

  setSeries(series: Highcharts.SeriesOptionsType[]) {
    this.options.series = series;
    return this;
  }

  setExporting(exporting: Highcharts.ExportingOptions) {
    this.options.exporting = { ...this.options.exporting, ...exporting };
    return this;
  }

  setPlotOptions(plotOptions: Highcharts.PlotOptions) {
    this.options.plotOptions = { ...this.options.plotOptions, ...plotOptions };
    return this;
  }

  setTooltip(tooltip: Highcharts.TooltipOptions) {
    this.options.tooltip = { ...this.options.tooltip, ...tooltip };
    return this;
  }

  build() {
    return this.options;
  }
}
